<template style="height:100%">
  <div class="ExamineStatistical CommonContentSingle-gray">
    <el-container>
          <div class="nav">
        <ul>
          <li style="margin-left:0px">
            <div class="right" style="margin-top:10px">
              <el-button @click="querycensus(1)" class="minbtn" style="width:60px;height:30px;margin-left:30px" size="mini">近一月</el-button>
              <el-button @click="querycensus(3)" class="minbtn" style="width:60px;height:30px;" size="mini">近三月</el-button>
              <el-button @click="querycensus(6)" class="minbtn" style="width:60px;height:30px;" size="mini">近半年</el-button>
              <el-button @click="querycensus(12)" class="minbtn" style="width:60px;height:30px" size="mini">近一年</el-button>
              <el-date-picker @change = 'changefun()' value-format="yyyy-MM-dd" format="yyyy-MM-dd" style="width: 220px;height: 32px;margin-left:20px"  v-model="time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
              <el-button type="primary" style="margin-left:20px;" @click="czfun()">重置</el-button>
            </div>
            <div ref="peopleNumByDegree" style="width:98%;height: 340px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;margin-top:20px"></div>
          </li>
          <li>
            <div ref="Trainingcontentstatistics" style="width: 98%;height:350px;margin: auto;margin-top:50px"></div>
          </li>
          <li style="margin-left:0px">
            <div ref="peopleNumByDegree2" style="width:98%;height: 340px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;margin-top:40px"></div>
          </li>
          <li>
            <div style="width: 49.5%;float: left;height: 100%;">
              <div ref="Piechart" style="width:98%;height: 340px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;margin-top:20px"></div>
            </div>
            <div style="width: 1%;height: 100%;background-color: rgb(235, 236, 237);float: left;"></div>
            <div style="width: 49.5%;float:left;height: 100%;">
              <div ref="Piechart2" style="width:98%;height: 340px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;margin-top:20px"></div>
            </div>
          </li>
        </ul>
      </div>
      <el-header class="ExamineStatistical-top">
        <div v-if="judge == '预约统计'">
          <h2>{{$t('original.languages344')}}</h2>
          <ul>
            <li>
              <h3>{{ TotalCounts }}</h3>
              <p>{{ $t('original.languages494') }}</p>
            </li>
            <li>
              <h3>{{ Subscribe }}</h3>
              <p>{{ $t('original.languages334') }}</p>
            </li>
            <li>
              <h3>{{ Consult }}</h3>
              <p>{{ $t('original.languages335') }}</p>
            </li>

            <li>
              <h3>{{ NonArrival }}</h3>
              <p>未来访人次</p>
            </li>

            <li>
              <h3>{{Reserve}}</h3>
              <p>已预约待更新</p>
            </li>

            <li>
              <h3>{{ ZxCancel }}</h3>
              <p>{{ $t('original.languages336') }}</p>
            </li>
            <li>
              <h3>{{ YuCancel }}</h3>
              <p>{{ $t('original.languages337') }}</p>
            </li>
            
          </ul>
        </div>
        <div v-else-if="judge == '劳务统计'">
          <h2>{{ $t('original.languages339') }}</h2>
          <ul>
            <li>
              <h3>{{ WorkingTime }}</h3>
              <p>{{ $t('original.languages494') }}</p>
            </li>

            <li>
              <h3>{{ ArrivalTime }}</h3>
              <p>已来访人次</p>
            </li>

            <li>
              <h3>{{ NotArrivalTime }}</h3>
              <p> 未来访人次</p>
            </li>
            

            <li>
              <h3>{{ ReserveTime }}</h3>
              <p>已预约待更新</p>
            </li>

            <li>
              <h3>{{ NotReserveTime }}</h3>
              <p>无预约</p>
            </li>
    
            <li>
              <h3>{{ LeaveTime }}</h3>
              <p>{{ $t('original.languages343') }}</p>
            </li>
          </ul>
        </div>
        <div v-else-if="judge == '总体统计'">
          <h2>{{ $t('original.languages493') }}</h2>
          <ul>
            <li>

              <h3>{{ getConsultationStatistics_Data.dutyCount }}</h3>
              <p>{{ $t('original.languages494') }}</p>
            </li>
            <li>
              <h3>{{ getConsultationStatistics_Data.appTotal }}</h3>
              <p>{{ $t('original.languages495') }}</p>
            </li>
            <li>
              <h3>{{ getConsultationStatistics_Data.consultationsTotal }}</h3>
              <p>{{ $t('original.languages496') }} </p>
            </li>
            <li>
              <h3>{{ getConsultationStatistics_Data.consultationsNum }}</h3>
              <p>{{ $t('original.languages497') }}  </p>
            </li>
            <li>
              <h3>{{ getConsultationStatistics_Data.highRiskTotal }}</h3>
              <p>{{ $t('original.languages498') }}  </p>
            </li>
            <li>
              <h3>{{ getConsultationStatistics_Data.highRisk }}</h3>
              <p>{{ $t('original.languages499') }}   </p>
            </li>

            <li>
              <h3>{{ getConsultationStatistics_Data.reportNum }}</h3>
              <p>危机上报人数   </p>
            </li>


          </ul>
        </div>
        <div v-else-if="judge == '薪资设置'">
          <h2>{{ $t('original.languages500') }}</h2>
          <ul>
            <li v-for="item in tableDataxz" :key="item.unitPriceKey">
              <h3>{{ item.totalNum1 }}</h3>
              <p>{{ item.position }}</p>
            </li>
          </ul>
        </div>
        <div v-else-if="judge == '咨询查询'">
          <h2>{{ $t('original.languages501') }}</h2>
          <ul>
            <li>
              <h3 v-text="PublicTable.allCount?PublicTable.allCount:'0'"></h3>
              <p> {{ $t('original.languages275') }}</p>
            </li>
            <li>
              <h3 v-text="PublicTable.missedCount?PublicTable.missedCount:'0'"></h3>
              <p>{{ $t('original.languages502') }}</p>
            </li>
            <li>
              <h3 v-text="PublicTable.selfCancelCount?PublicTable.selfCancelCount:'0'"></h3>
              <p>{{ $t('original.languages503') }} </p>
            </li>
            <li>
              <h3 v-text="PublicTable.consultCancelCount?PublicTable.consultCancelCount:'0'"></h3>
              <p>{{ $t('original.languages504') }}  </p>
            </li>
          </ul>
        </div>
      </el-header>
      <div class="ExamineStatistical-nav">
        <div>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="$t('original.languages493')" name="fourth">
              <el-form :inline="true" class="demo-form-inline">
                <el-form-item :label="$t('original.Name_of_Company')">
                  <el-cascader ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen" :options="data"
                  :props="{ checkStrictly: true }" clearable :placeholder="$t('original.languages3')"></el-cascader>
                </el-form-item>
                <el-form-item :label="$t('original.languages445')">
                  <el-select v-model="ztdata.campus" :placeholder="$t('original.languages3')">
                    <el-option v-for="item in SensoryProblemsList" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey">
                    </el-option>
                  </el-select>
                </el-form-item>


                <el-form-item :label="$t('original.languages505')">
                  <el-select v-model="ztdata.profCode" filterable :placeholder="$t('original.languages3')">
                    <el-option v-for="item in zhuanyeList" :key="item.eDicValue" :label="item.cDicValue" :value="item.eDicValue">
                    </el-option>
                  </el-select>
                </el-form-item>



                <el-form-item :label="$t('original.languages345')">
                  <el-date-picker type="daterange"  value-format="yyyy-MM-dd" v-model="ztdata.Date" :range-separator="$t('original.languages296')" :start-placeholder="$t('original.languages346')" :end-placeholder="$t('original.languages347')" unlink-panels></el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('original.languages506')">
<!-- 研究所1  专业2 校区3 -->
                <el-radio-group v-model="ztdata.dimention">
                  <el-radio label="3">{{$t('original.languages445')}}</el-radio>
                  <el-radio label="1">{{$t('original.Name_of_Company')}}</el-radio>
                  <el-radio label="2">{{$t('original.languages505')}}</el-radio>
                  <el-radio label="4">咨询主题</el-radio>
                  <el-radio label="5">咨询方式</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSubmit">{{$t('original.languages470')}}</el-button>
                <el-button type="primary" @click="onSubmit2">{{$t('original.languages154')}}</el-button>
                <el-button type="primary" @click="resetone()">{{$t('original.reset')}}</el-button>
              </el-form-item>
              </el-form>
              <div>
                男性完成数：{{getConsultationStatistics_Data.summary.manCount}}
                女性完成数：{{getConsultationStatistics_Data.summary.womanCount}}
                本一完成数：{{getConsultationStatistics_Data.summary.uone}}
                本二完成数：{{getConsultationStatistics_Data.summary.utwo}}
                本三完成数：{{getConsultationStatistics_Data.summary.uthree}}
                本四完成数：{{getConsultationStatistics_Data.summary.ufour}}
                硕一完成数：{{getConsultationStatistics_Data.summary.pone}}
                硕二完成数：{{getConsultationStatistics_Data.summary.ptwo}}
                硕三完成数：{{getConsultationStatistics_Data.summary.pthree}}
                博一完成数：{{getConsultationStatistics_Data.summary.done}}
                博二完成数：{{getConsultationStatistics_Data.summary.dtwo}}
                博三完成数：{{getConsultationStatistics_Data.summary.dthree}}
                职工完成数：{{getConsultationStatistics_Data.summary.empCount}}
              </div>
              <el-table :data="getConsultationStatistics_Data.details" style="width: 100%;margin-top: 10px;">
                <el-table-column prop="name" label="统计维度"></el-table-column>
                <el-table-column label="总人数">
                  <template slot-scope="scope">
                    <span>{{ scope.row.manCount  + scope.row.womanCount}}</span>
                  </template>
                </el-table-column>

                <el-table-column prop="manCount" label="男性完成数"></el-table-column>
                <el-table-column prop="womanCount" label="女性完成数"></el-table-column>
                <el-table-column prop="uone" label="本一完成数"></el-table-column>
                <el-table-column prop="utwo" label="本二完成数"></el-table-column>
                <el-table-column prop="uthree" label="本三完成数"></el-table-column>
                <el-table-column prop="ufour" label="本四完成数"></el-table-column>
                <el-table-column prop="pone" label="硕一完成数 "></el-table-column>
                <el-table-column prop="ptwo" label="硕二完成数 "></el-table-column>
                <el-table-column prop="pthree" label="硕三完成数 "></el-table-column>
                <el-table-column prop="done" label="博一完成数 "></el-table-column>
                <el-table-column prop="dtwo" label="博二完成数 "></el-table-column>
                <el-table-column prop="dthree" label="博三完成数 "></el-table-column>
                <el-table-column prop="empCount" label="职工完成数 "></el-table-column>
              </el-table>
              <el-pagination @size-change="handleSizeChange5" @current-change="handleCurrentChange5" :current-page.sync="currentPag5" :page-size="10" layout="total, prev, pager, next" :total="Counts5"></el-pagination>
            </el-tab-pane>
            <el-tab-pane v-if="!this.Global.pdroleid(1065)" :label="$t('original.languages344')" name="first">
              <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item :label="$t('original.languages225')">
                  <el-input v-model="formInline.Name" :placeholder="$t('original.languages349')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('original.languages345')">
                  <el-date-picker type="daterange"  value-format="yyyy-MM-dd" v-model="formInline.Date" :range-separator="$t('original.languages296')" :start-placeholder="$t('original.languages346')" :end-placeholder="$t('original.languages347')" unlink-panels></el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('original.user_types')">
                  <el-select v-model="formInline.RoleID" :placeholder="$t('original.languages15')">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="学生" value="1058"></el-option>
                    <el-option label="教职工" value="1075"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="Thequery">{{ $t('original.screening') }}</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="reset">{{ $t('original.reset') }}</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="exports">{{ $t('original.languages154') }}</el-button>
                </el-form-item>
              </el-form>
              <el-table v-loading="loadings" :row-key=" (row) => {return row.Counts;}" :data="tableData" style="width: 100%; margin-top: 10px" :default-sort="{ prop: 'date', order: 'descending' }">
                <el-table-column :label="$t('original.The_serial_number')" min-width="6%">
                  <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('original.languages225')" min-width="15%" align="left">
                  <template slot-scope="scope" align="left">
                    <span>{{ scope.row.Name }}</span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('original.languages334')" min-width="10%">
                  <template slot-scope="scope">
                    <span>{{ scope.row.Subscribe }}</span>
                  </template>
                </el-table-column>

                <el-table-column :label="$t('original.languages335')" min-width="10%">
                  <template slot-scope="scope">
                    <span>{{ scope.row.Consult }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="未来访人次" min-width="10%">
                  <template slot-scope="scope">
                    <span>{{ scope.row.NonArrival }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="已预约待更新" min-width="10%">
                  <template slot-scope="scope">
                    <span>{{ scope.row.Reserve }}</span>
                  </template>
                </el-table-column>



                <el-table-column :label="$t('original.languages336')" min-width="10%">
                  <template slot-scope="scope">
                    <span>
                      {{ scope.row.ZxCancel }}
                    </span>
                  </template>
                </el-table-column>
                
                <!-- <el-table-column label="$t('original.languages338')" min-width="10%">
                  <template slot-scope="scope">
                    <span>{{ scope.row.NonArrival }}</span>
                  </template>
                </el-table-column> -->


                <el-table-column :label="$t('original.languages337')" min-width="10%">
                  <template slot-scope="scope">
                    <span>{{ scope.row.YuCancel }}</span>
                  </template>
                </el-table-column>


                <el-table-column :label="$t('original.languages550')" min-width="10%">
                  <template slot-scope="scope">
                    <span>{{ scope.row.ScheduleCount }}</span>
                  </template>
                </el-table-column>


                <el-table-column :label="$t('original.languages49')" min-width="15%">
                  <template slot-scope="scope">
                    <el-button size="mini"  @click="handleEdit(scope.$index, scope.row)">
                      {{ $t('original.languages174') }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="block" v-if="tableData.length > 0">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPag" :page-size="10" layout="total, prev, pager, next" :total="Counts"></el-pagination>
              </div>
            </el-tab-pane>

            <el-tab-pane v-if="!this.Global.pdroleid(1065)" :label="$t('original.languages348')" name="second">
              <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item :label="$t('original.languages225')">
                  <el-input v-model="formInline2.Name" :placeholder="$t('original.languages349')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('original.languages345')">
                  <el-date-picker type="daterange" value-format="yyyy-MM-dd" v-model="formInline2.Date" :range-separator="$t('original.languages296')" :start-placeholder="$t('original.languages346')" :end-placeholder="$t('original.languages347')" unlink-panels ></el-date-picker>
                </el-form-item>
                
                <el-form-item>
                  <el-button type="primary" @click="Thequery2">{{ $t('original.screening') }}</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="reset2">{{ $t('original.reset') }}</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="export2">{{ $t('original.languages154') }}</el-button>
                </el-form-item>
              </el-form>

              <p>总计：{{ totalMny }}</p>
              <el-table v-loading="loadings" 
                :row-key="(row) => {return row.Counts;}" 
                :data="tableData2" 
                style="width: 100%; margin-top: 10px" 
                :default-sort="{ prop: 'date', order: 'descending' }">
                <el-table-column :label="$t('original.The_serial_number')" min-width="6%">
                  <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('original.languages225')" min-width="10%" align="left">
                  <template slot-scope="scope" align="left">
                    <span>{{ scope.row.ZxName }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="已来访（h）" min-width="10%" align="left">
                  <template slot-scope="scope" align="left">
                    <span>{{ scope.row.ArrivalTime }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="未来访（h）" min-width="10%" align="left">
                  <template slot-scope="scope" align="left">
                    <span>{{ scope.row.NotArrivalTime }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="已预约待更新（h）" min-width="10%" align="left">
                  <template slot-scope="scope" align="left">
                    <span>{{ scope.row.ReserveTime }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="无预约（h）" min-width="10%" align="left">
                  <template slot-scope="scope" align="left">
                    <span>{{ scope.row.NotReserveTime }}</span>
                  </template>
                </el-table-column>

                <!-- <el-table-column :label="$t('original.languages341')+'（h）'" min-width="10%">
                  <template slot-scope="scope">
                    <span>{{ scope.row.ConsultTime }}</span>
                  </template>
                </el-table-column>

                <el-table-column :label="$t('original.languages342')+'（h）'" min-width="10%">
                  <template slot-scope="scope">
                    <span>{{ scope.row.KeepTime }}</span>
                  </template>
                </el-table-column> -->

                
                <el-table-column :label="$t('original.languages507')+'（h）'" min-width="10%">
                  <template slot-scope="scope">
                    <span>{{ scope.row.HolidayTime }}</span>
                  </template>
                </el-table-column>

                <el-table-column :label="$t('original.languages343')+'（h）'" min-width="10%">
                  <template slot-scope="scope">
                    <span> {{ scope.row.LeaveTime }} </span>
                  </template>
                </el-table-column>

                <el-table-column :label="$t('original.languages340')+'（h）'" min-width="10%">
                  <template slot-scope="scope">
                    <span>{{ scope.row.WorkingTime }}</span>
                  </template>
                </el-table-column>

                <el-table-column :label="$t('original.languages508')"  min-width="10%">
                  <template slot-scope="scope">
                    <span>{{ scope.row.Salary }}</span>
                  </template>
                </el-table-column>

              </el-table>

              <div class="block" v-if="tableData2.length > 0">
                <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page.sync="currentPag2" :page-size="10" layout="total, prev, pager, next" :total="Counts2"></el-pagination>
              </div>
            </el-tab-pane>

            <el-tab-pane v-if="!this.Global.pdroleid(1065)" :label="$t('original.languages509')" name="third">
              <el-table :data="tableDataxz" style="width: 100%">
                <el-table-column prop="position" :label="$t('original.languages510')" width="180"></el-table-column>
                <el-table-column prop="unitPrice" :label="$t('original.languages511')" width="180"></el-table-column>
                <el-table-column prop="dutyUnitPrice" :label="$t('original.languages512')" width="180"></el-table-column>
                <el-table-column :label="$t('original.languages49')" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span class="copy_Button" @click="todialogVisible(scope.row)">{{$t('original.languages57')}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>

            <el-tab-pane v-if="!this.Global.pdroleid(1065)" :label="$t('original.languages501')" name="fived">
              <el-form :model="statisticsData">
                <el-form-item>
                  <el-row>
                    <el-col :span="1" style="text-align: center;min-width:60px;">{{$t('original.languages513')}}</el-col>
                    <el-col :span="4"><el-input v-model="statisticsData.detailVO.Conditions" :placeholder="$t('original.languages514')" style="width: 90%;"></el-input></el-col>
                    <el-col :span="1" style="text-align: center;min-width:60px;">{{$t('original.languages445')}}</el-col>
                    <el-col :span="4">
                      <el-select v-model="statisticsData.detailVO.Campus" clearable :placeholder="$t('original.languages3')" style="width: 90%;">
                      <el-option v-for="item in SensoryProblemsList"  :key="item.dicKey"  :label="item.cDicValue"  :value="item.dicKey"></el-option>
                    </el-select>
                    </el-col>
                    <el-col :span="1" style="text-align: center;min-width:60px;">{{$t('original.languages212')}}</el-col>
                    <el-col :span="4">
                      <el-select v-model="statisticsData.detailVO.ConsultType" clearable :placeholder="$t('original.languages3')"  style="width: 90%;">
                      <el-option v-for="item in Consultationmethods" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    </el-col>
                    <el-col :span="1" style="text-align: center;min-width:60px;">状&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;态</el-col>
                    <el-col :span="4">
                      <el-select v-model="statisticsData.detailVO.States" clearable :placeholder="$t('original.languages3')" multiple style="width: 90%;">
                      <el-option v-for="item in StatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    </el-col>
                  </el-row>
                </el-form-item>

                <el-form-item>
                  <el-row>
                    <el-col :span="1" style="text-align: center;min-width:60px;">{{$t('original.languages225')}}</el-col>
                    <el-col :span="4"><el-input v-model="statisticsData.detailVO.ConsultName" type="text" :placeholder="$t('original.languages515')" style="width: 90%;"></el-input></el-col>
                    <el-col :span="1" style="text-align: center;min-width:60px;">{{$t('original.languages461')}}</el-col>
                    <el-col :span="4">
                      <el-select v-model="statisticsData.detailVO.SchedulType" clearable :placeholder="$t('original.languages3')" style="width: 90%;">
                      <el-option v-for="item in Rostertype" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    </el-col>
                    <el-col :span="1" style="text-align: center;min-width:60px;">{{$t('original.languages516')}}</el-col>
                    <el-col :span="4">
                      <el-select v-model="statisticsData.detailVO.Crisis" clearable :placeholder="$t('original.languages3')" style="width: 90%;">
                        <el-option v-for="item in Warningstatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="1" style="text-align: center;min-width:60px;">{{$t('original.languages272')}}</el-col>
                    <el-col :span="4">
                      <el-date-picker style="width: 90%;" v-model="detailVOConsultTime" type="daterange" :range-separator="$t('original.languages296')" value-format="yyyy-MM-dd" :start-placeholder="$t('original.languages346')" :end-placeholder="$t('original.languages347')"></el-date-picker>
                    </el-col>
                  </el-row>
                </el-form-item>
                
                <el-form-item>
                  <el-col :span="1" style="text-align: center;min-width:60px;">{{$t('original.languages311')}}</el-col>
                    <el-col :span="4">
                      <el-date-picker style="width: 90%;" v-model="detailVOAppointmentTime" type="daterange" value-format="yyyy-MM-dd" :start-placeholder="$t('original.languages346')" :end-placeholder="$t('original.languages347')">
                      </el-date-picker>
                    </el-col>
                    <el-col :span="1" style="text-align: center;min-width:60px;">{{$t('original.languages517')}}</el-col>
                    <el-col :span="4">
                      <el-select v-model="statisticsData.detailVO.Degree" clearable :placeholder="$t('original.languages3')" style="width: 90%;">
                        <el-option v-for="item in educationalstage" :key="item.value" :label="item.label" :value="item.value"></el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="1" style="text-align: center;min-width:60px;">{{$t('original.gender')}}</el-col>
                    <el-col :span="4">
                      <el-select v-model="statisticsData.detailVO.Sex" clearable :placeholder="$t('original.languages3')" style="width: 90%;">
                        <el-option key="0" label="女" value="0"></el-option>
                        <el-option key="1" label="男" value="1"></el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="1" style="text-align: center;min-width:60px;">{{$t('original.languages518')}}</el-col>
                    <el-col :span="4">
                      <el-select v-model="statisticsData.detailVO.DataType" clearable :placeholder="$t('original.languages3')" style="width: 90%;">
                        <el-option key="1" label="预约记录" value="1"></el-option>
                        <el-option key="2" label="候补记录" value="2"></el-option>
                      </el-select>
                    </el-col>
                </el-form-item>
                <el-form-item style="margin-bottom: 0;">
                  <el-col :span="1" style="text-align: center;min-width:60px;">{{$t('original.languages208')}}</el-col>
                    <el-col :span="4">
                      <el-select v-model="statisticsData.detailVO.ConsultSubject" clearable :placeholder="$t('original.languages3')" style="width: 90%;">
                        <el-option v-for="item in subjectData" :key="item.dicKey" :label="item.cDicValue" :value="item.dicKey"></el-option>
                      </el-select>
                    </el-col>
                    <el-button type="primary" @click="Consultationquerystatistics(0)">{{$t('original.languages470')}}</el-button>
                    <el-button type="primary" @click="ClickReset">{{$t('original.reset')}}</el-button>
                </el-form-item>
              </el-form>
              <tabletest style="margin-top: -10px;" v-model="PublicTable" :currentPage="statisticsData.pageNum" :PageSize="statisticsData.pageSize"  :PageTotal="statisticsData.PageTotal" :PageName="`ExamineStatistical`" @handleinitialization="handleinitialization"
              ></tabletest>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </el-container>
    
    <el-drawer :visible.sync="drawer" :with-header="false">
      <el-button type="primary" @click="export3">{{$t('original.languages154')}}</el-button>
      <p class="csadxscvf">{{ $t('original.languages354') }}（{{ Counts3 }} 人次）</p>
      <el-table v-loading="loadings" :row-key="(row) => {return row.Counts;}" :data="tableData3" style="width: 100%;margin-top: 10px" :default-sort="{ prop: 'date', order:'descending' }">
        <el-table-column :label="$t('original.languages79')" min-width="10%" align="left">
          <template slot-scope="scope" align="left">
            <span>{{ scope.row.UserID }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('original.languages207')" min-width="10%">
          <template slot-scope="scope">
            <span>{{ scope.row.Name }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('original.languages208')" min-width="15%">
          <template slot-scope="scope">
            <span>{{ scope.row.ConsultTheme }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('original.languages272')" min-width="10%">
          <template slot-scope="scope">
            <span>
              {{ scope.row.AppointmentTime }}
            </span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('original.languages212')" min-width="10%">
          <template slot-scope="scope">
            <span>{{ scope.row.ConsultType }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('original.languages355')" min-width="10%">
          <template slot-scope="scope">
            <span>{{ scope.row.Status }}</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="block" style="padding-bottom: 50px;" v-if="tableData3.length > 0">
        <el-pagination @size-change="handleSizeChange3" @current-change="handleCurrentChange3" :current-page.sync="currentPag3" :page-size="10" layout="total, prev, pager, next" :total="Counts3">
        </el-pagination>
      </div>

    </el-drawer>

    <el-dialog :title="$t('original.languages519')" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <div>
        <span>{{$t('original.languages520')}}：</span> <span>{{ shixin.position }}</span>
      </div>
      <div class="xsjoij" style="padding-top: 20px;">
        <span>{{$t('original.languages511')}}：</span>
        <el-input type="number" :min="0" v-model="unitPrice" :placeholder="$t('original.languages521')"></el-input>
      </div>
      <div class="xsjoij" style="padding-top: 20px;">
        <span>{{$t('original.languages512')}}：</span>
        <el-input type="number" :min="0" v-model="dutyUnitPrice" :placeholder="$t('original.languages521')"></el-input>
      </div>
      <el-button style="margin-top: 20px;margin-left: 170px;" type="primary" @click="Salary_modification()">{{$t('original.languages57')}}</el-button>
    </el-dialog>
  </div>
</template>
<script>
import tabletest from '@/components/table_test.vue'
export default {
  data() {
    return {
      getSummaryDetailReportdata:[],
      RoleID:sessionStorage.getItem('RoleID'),
      getConsultationStatistics_Data:'',
      shixin: '',
      unitPrice:'',
      dutyUnitPrice: '',
      dialogVisible:false,
      SensoryProblemsList: [],
      zhuanyeList: [],
      ztdata: {
        realName:'',
        campus:'',
        deptID:'',
        profCode:'',
        sex:'',
        pageNo: 1,
        dimention:'3',
        Date:[]
      },
      data:[],
      numder: 0,
      drawer: false,
      loadings: false,
      Counts: 0,
      Counts2: 0,
      Counts5: 0,
      currentPag: 1,
      currentPag2: 1,
      currentPag3: 1,
      currentPag5: 1,
      tableData3: [],
      tableDataxz: [],
      Counts3: 0,
      tableData: [],
      tableData2: [],
      totalMny:0,
      judge: "总体统计",
      activeName: "fourth",
      formInline: {
        Name: "",
        DeriveText: "0",
        pageSize: "10",
        pageIndex: "1",
        Language: "Chinese",
        Date: [],
        RoleID:''
      },
      formInline2: {
        Name: "",
        Date: [],
        pageSize: "10",
        pageIndex: "1",
        DeriveText: "0",//是否需要导出
        Language: "Chinese",
      },
      formInline3: {
        UserID: "",
        pageSize: "10",
        pageIndex: "1",
        DeriveText: "0", //是否需要导出
        Language: "Chinese",
      },
      TotalCounts: "0", //个体咨询总
      Subscribe: "0", //预约人次
      Consult: "0", //已到访人次
      ZxCancel: "0", //咨询师取消
      YuCancel: "0", //来访者取消
      NonArrival: "0", //预约未到
      WorkingTime: "0", //排班时常
      ConsultTime: "0", //咨询时长
      Reserve:'0',
      ArrivalTime:'',
      NotArrivalTime:'',
      NotReserveTime:'',
      ReserveTime:'',

      KeepTime: "0", //坐班时长
      LeaveTime: "0", //请假时长
      // 预约咨询查询
      value:'',
      PublicTable:{
        operate:{
          isshow: false,
          operateName: "操作"
        }
      },
      detailVOConsultTime:[],
      detailVOAppointmentTime:[],
      statisticsData:{
        pageNum:1,
        PageTotal:0,
        pageSize:10,
        detailVO:{
          Conditions:'',//综合查询条件
          Campus:'',//校区
          ConsultName:'',//咨询师
          ConsultType:'',//咨询方式
          States:[],//状态
          Crisis:'',//预警状态
          SchedulType:'',//排班类型
          Degree:"",//教育阶段
          Sex:'',
          ConsultSubject:'',
          DataType:'',//是否候补
          ConsultStartTime:'',
          ConsultEndTime:'',
          AppointmentStartTime:'',
          AppointmentEndTime:''
        }
      },
      StatusList:[
        {value:1,label:'预约'},
        {value:2,label:'自主取消'},
        {value:3,label:'心理中心取消'},
        {value:4,label:'未来访'},
        {value:5,label:'已来访（准时）'},
        {value:6,label:'已来访（迟到）'},
      ],
      educationalstage:[
        {value:'本科生',label:'本科生'},
        {value:'硕士研究生',label:'硕士研究生'},
        {value:'博士研究生',label:'博士研究生'}
      ],
      subjectData:[],
      Warningstatus:[{value:0,label:'正常'},{value:1,label:'预警'}],
      Rostertype:[{value:0,label:'普通排班'},{value:1,label:'特殊排班'}],
      Consultationmethods:[{value:0,label:'面对面咨询'},{value:1,label:'视频咨询'}],
      beginTime:[],
      endTime:[],
      time:this.Global.querycensus(6),
    };
    
  },
  watch:{
    'detailVOConsultTime':{
      handler:function(newval,oldval){
        if(newval==null || newval==""){
          this.statisticsData.detailVO.ConsultStartTime = '';
          this.statisticsData.detailVO.ConsultEndTime = '';
        } else {
          this.statisticsData.detailVO.ConsultStartTime = newval[0];
          this.statisticsData.detailVO.ConsultEndTime = newval[1];
        }
      }
    },
    'detailVOAppointmentTime':{
      handler:function(newval,oldval){
        if(newval==null || newval==""){
          this.statisticsData.detailVO.AppointmentStartTime = '';
          this.statisticsData.detailVO.AppointmentEndTime = '';
        }else{
          this.statisticsData.detailVO.AppointmentStartTime = newval[0];
          this.statisticsData.detailVO.AppointmentEndTime = newval[1];
        }
      }
    },
  },
  methods: {

    czfun(){
      this.beginTime = this.Global.querycensus(12)[0]
      this.endTime = this.Global.querycensus(12)[1]
      this.fungetSummaryDetailReport()
    },
    
    querycensus(data){
      const censusDate= this.Global.querycensus(data);
      this.beginTime=censusDate[0];
      this.endTime=censusDate[1];
      this.fungetSummaryDetailReport();
    },

    fungetSummaryDetailReport(){
      this.$Http_Post('statistics/getSummaryDetailReport', {from:this.beginTime,to:this.endTime}).then((res) => {
        if (res.code == 200 || res.Code == 0) {
          this.getSummaryDetailReportdata = res.Data;
          this.$nextTick(() => {
            this.peopleNumByDegree();
            this.peopleNumByDegree2();
            this.Piechart();
            this.Piechart2();
            this.Trainingcontentstatistics();
          });

          
        }
      })
    },
    changefun(){
      this.$Http_Post('statistics/getSummaryDetailReport', {from:this.time[0],to:this.time[1]}).then((res) => {
        if (res.code == 200 || res.Code == 0) {
          this.getSummaryDetailReportdata = res.Data;
          this.$nextTick(() => {
            this.peopleNumByDegree();
            this.peopleNumByDegree2();
            this.Piechart();
            this.Piechart2();
            this.Trainingcontentstatistics();
          });
        }
      })
    },
    peopleNumByDegree(data) {
      var absentSum = []//缺席
      var cancelSum = []//取消
      var consultSum = []//咨询和
      var dateStr = []
      var reserveSum = []//储备和
      var scheduleSum = []//时间表和
      for(var j = 0;j < this.getSummaryDetailReportdata.totalList.length;j++){
        absentSum.push( this.getSummaryDetailReportdata.totalList[j].absentSum)
        cancelSum.push( this.getSummaryDetailReportdata.totalList[j].cancelSum)
        consultSum.push(this.getSummaryDetailReportdata.totalList[j].consultSum)
        dateStr.push( this.getSummaryDetailReportdata.totalList[j].dateStr)
        reserveSum.push(this.getSummaryDetailReportdata.totalList[j].reserveSum)
        scheduleSum.push(this.getSummaryDetailReportdata.totalList[j].scheduleSum)
      }
      var myChart = this.$echarts.init(this.$refs.peopleNumByDegree);
      var option = {
        tooltip: {
           trigger: 'axis'
        },
        title: {
          text: '总体统计图表',
          left: '20px',
          top: '10px',
        },
        legend: {
          data: ['预约人数','咨询人数','心理中心取消','预约未到'],
          top: '10px',
          left:'160px',
        },
        xAxis: {
          type: 'category',
          data: dateStr
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name:'预约人数',
            data: reserveSum,
            type: 'line',
            smooth: true,
            color: 'rgba(227, 181, 64, 1)'  
          },
          {
            name:'咨询人数',
            data: consultSum,
            type: 'line',
            smooth: true,
            color: 'rgba(156, 196, 54, 1)'  
          },
          {
            name:'心理中心取消',
            data: cancelSum,
            type: 'line',
            smooth: true,
            color: 'rgba(255, 84, 84, 1)'  
          },
          {
            name:'预约未到',
            data: absentSum,
            type: 'line',
            smooth: true,
            color: 'rgba(85, 124, 217, 1)'  
          },
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    peopleNumByDegree2(data) {
      var xValList = [];//月
      var seriesList = [];
      var yValList = [];
       if(this.getSummaryDetailReportdata.campusList[0].campusList.length > 0){
          for(var j = 0;j < this.getSummaryDetailReportdata.campusList[0].campusList.length;j++){
            seriesList.push(
              {
                name:this.getSummaryDetailReportdata.campusList[0].campusList[j].campus, 
                data: [],
                type: 'line',
                smooth: true
              }
            );
          }
        }
        for(var j = 0;j < this.getSummaryDetailReportdata.campusList.length;j++){
          xValList.push(this.getSummaryDetailReportdata.campusList[j].dateStr);
        }
        if(seriesList.length > 0){
          for(var i = 0;i < seriesList.length;i++){
            for(var j = 0;j < this.getSummaryDetailReportdata.campusList.length;j++){
              seriesList[i].data.push(this.getSummaryDetailReportdata.campusList[j].campusList[i].sum);
            }
          }
        }
      var myChart = this.$echarts.init(this.$refs.peopleNumByDegree2);
      var option = {
        tooltip: {
           trigger: 'axis'
        },
        title: {
          text: '各校区咨询人数统计',
          left: '20px',
          top: '10px',
        },
        legend: {
          // data: yValList,
          top: '10px',
          left:'200px',
        },
        xAxis: {
          type: 'category',
          data: xValList
        },
        yAxis: {
          type: 'value'
        },
        series: seriesList
      };
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    Piechart(){
      var myChart = this.$echarts.init(this.$refs.Piechart);
      var option = {
        tooltip: {
          trigger: 'item'
        },
        color:['rgba(147, 194, 45, 1)', 'rgba(85, 124, 217, 1)', 'rgba(255, 185, 56, 1)'],
        title: {
          text: '咨询人数(学历)',
          left: '20px',
          top: '10px',
        },
        legend: {
          top: '90%',
          left: 'center',
          selectedMode: false
        },
        series: [
          {
            type: 'pie',
            radius: ['40%','60%'],
            data: [
              { value: this.getSummaryDetailReportdata.degree1,name: '本科' },
              { value: this.getSummaryDetailReportdata.degree2, name: '硕士' },
              { value: this.getSummaryDetailReportdata.degree3, name: '博士' },
            ]
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    Piechart2(){
      var myChart = this.$echarts.init(this.$refs.Piechart2);
      var option = {
        tooltip: {
          trigger: 'item'
        },
        color:['rgba(255, 185, 56, 1)', 'rgba(85, 124, 217, 1)'],
        title: {
          text: '咨询人数(性别)',
          left: '20px',
          top: '10px',
        },
        legend: {
          top: '90%',
          left: 'center',
          selectedMode: false
        },
        series: [
          {
            type: 'pie',
            radius: ['40%','60%'],
            data: [
              { value: this.getSummaryDetailReportdata.male,name: '男' },
              { value: this.getSummaryDetailReportdata.female, name: '女' },
            ]
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    Trainingcontentstatistics(){
      var crisisSum = []
      var dateStr= []
      var notCrisisSum= []
      var reportSum= []
      for(var j = 0;j < this.getSummaryDetailReportdata.crisisList.length;j++){
        crisisSum.push(this.getSummaryDetailReportdata.crisisList[j].crisisSum)
        dateStr.push(this.getSummaryDetailReportdata.crisisList[j].dateStr)
        notCrisisSum.push(this.getSummaryDetailReportdata.crisisList[j].notCrisisSum)
        reportSum.push(this.getSummaryDetailReportdata.crisisList[j].reportSum)
      }
      var myChart = this.$echarts.init(this.$refs.Trainingcontentstatistics);
      var option={
        tooltip: {
           trigger: 'axis'
        },
        legend: {},
        xAxis: {
          type: 'category',
          data: dateStr
        },
        yAxis: { splitLine: { show: true, lineStyle: { type: 'dashed' } } },
        series: [
          { 
            name:'高危个案人数', 
            data: crisisSum,
            type: 'bar',
            barWidth: '15', 
            itemStyle:{  
              normal:{   
                color:'rgba(255, 185, 56, 1)' // 这里可以设置柱状图的颜色  
              }  
            },  
          },{ 
            name:'非高危个案人数', 
            data: notCrisisSum,
            type: 'bar',
            barWidth: '15', 
            itemStyle:{  
              normal:{   
                color:'rgba(0, 186, 173, 1)' // 这里可以设置柱状图的颜色  
              }  
            },  
          },{ 
            name:'危机上报人数', 
            data: reportSum,
            type: 'bar',
            barWidth: '15', 
            itemStyle:{  
              normal:{   
                color:'rgba(255, 84, 84, 1)' // 这里可以设置柱状图的颜色  
              }  
            },  
          }, 
        ]
      }
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    resetone(){
      this.ztdata = {
        realName:'',
        campus:'',
        deptID:'',
        profCode:'',
        sex:'',
        pageNo: 1,
        dimention:'3',
        Date:[]
      }
      this.$refs.wcascader.$refs.panel.checkedValue = []; 
      this.getConsultationStatistics();
    },
    onSubmit() {
      this.getConsultationStatistics();
    },
     // 设置时间选择 默认 本月一号到今天
    setSelectTime() {
      var _this = this;
      var date = new Date();
      var y = date.getFullYear();
      var m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var start_month = y + '-' + '01'; //开始月份：本年第一月份
      var end_month = `${y}-${m}`; //结束月份： 本年当前月份
      // this.start_day = y + '-' + m + '-' + '01'; //开始日期： 本月第一天
      // this.end_day = `${y}-${m}-${d}`; //结束日期： 本月今天
      this.formInline2.Date[0] =  y + '-' + m + '-' + '01'; //开始日期： 本月第一天
      this.formInline2.Date[1] = `${y}-${m}-${d}`; //结束日期： 本月今天
      // _this.aa = [start_month, end_month]; //默认月份区间
      // _this.date = [start_day, end_day]; //默认日期区间  页面显示的
      // this.queryForm.strstartdate = start_day;   // 传入后台的 开始时间
      // this.queryForm.strenddate = end_day;		 // 传入后台的 结束时间
    },
    onSubmit2() {
      this.$Http_Post('/statistics/export', {
        realName: this.ztdata.realName, campus: this.ztdata.campus, deptID: this.ztdata.deptID, profCode: this.ztdata.profCode, sex: this.ztdata.sex, dimention: this.ztdata.dimention,from:this.ztdata.Date[0],to:this.ztdata.Date[1]
      }).then((res) => {
        if (res.code == 200 || res.Code == 0) {
          window.open(res.Data, "titlebar=0");
            // process.env.VUE_APP_URL + 'File/PMS/logo/systemwhite.png'
        }
      });
    },
    getConsultationStatistics() {
      this.$Http_Post('/statistics/getConsultationStatistics', {
        realName: this.ztdata.realName, campus: this.ztdata.campus, deptID: this.ztdata.deptID, profCode: this.ztdata.profCode, sex: this.ztdata.sex, pageNo : this.ztdata.pageNo, pageSize: "10", dimention: this.ztdata.dimention,from:this.ztdata.Date[0],to:this.ztdata.Date[1]
      }).then((res) => {
        if (res.code == 200 || res.Code == 0) {
          this.getConsultationStatistics_Data = res.Data;
          this.Counts5 =  Number(res.Counts);
          this.querycensus(12);
        }
      });
    },
    unitPrice_list() {
      this.$Http_Post('/consult/unitPrice/list', {positionKey:'',position:'',moduleKey:'',unitPrice:'',isActive:'',pageIndex:'1',pageSize:"10"}).then((res) => {
        if (res.code == 200 || res.Code == 0) {
          this.tableDataxz = res.Data;
        }
      });
    },
    Salary_modification() {
      if (this.unitPrice >= 0) {
        if (this.dutyUnitPrice >= 0) {
          this.$Http_Post('/consult/unitPrice/edit', {"unitPriceKey": this.shixin.unitPriceKey, "positionKey": '', "position": '', "moduleKey": '', "unitPrice": '', "isActive": '', "unitPrice": this.unitPrice, "dutyUnitPrice": this.dutyUnitPrice}).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.Global.request_successful(res.Message);
              this.unitPrice_list();
              this.dialogVisible = false;
            } else {
              this.Global.request_failure(res.Message);
            }
          })
        } else {
          alert("时薪不能小于0")
        }
      } else {
        alert("时薪不能小于0")
      }
      
    },
    todialogVisible(r) {
      this.shixin = r
      this.unitPrice = r.unitPrice
      this.dutyUnitPrice = r.dutyUnitPrice
      this.dialogVisible = true
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    Selected_to_shut_dow(dt) {
      this.ztdata.deptID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null;
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i];
          break
        } else if (NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children);
          if (obj != null) break
        }
      }
      return obj;
    },
    bumen(dt) {
      let obj = this.data[0];
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].DeptID == dt[dt.length - 1]) {
          obj = this.data[i];
        } else if (this.data[i].fuzi && this.data[i].children.length > 0 && this.data[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(dt[dt.length - 1], this.data[i].children);
        }
      }
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: this.$t('original.languages22') }];
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: dt[dt.length - 1], content: '' }).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        })
      }
    },
    handleEdit(a, b) {
      this.drawer = true;
      this.formInline3.DeriveText = 0;
      this.formInline3.UserID = b.UserID;
      this.SheMessageStatisticLaif();
    },
    Thequery() {//查询
      this.formInline.DeriveText = 0;
      this.Consultingstatistics();
      this.SheMessageStatisticSB();
    },
    reset() {
      this.formInline.Name = "";
      this.formInline.Date = [];
      this.formInline.pageSize = "10";
      this.formInline.pageIndex = "1";
      this.formInline.DeriveText = "0";
      this.Consultingstatistics();
      this.SheMessageStatisticSB();
    },
    exports() {
      this.formInline.DeriveText = 1;
      this.Consultingstatistics();
    },
    handleSizeChange(obj, e) {

    },
    handleSizeChange5(obj, e) {

    },
    handleCurrentChange5(obj, e) {
      this.ztdata.pageNo = obj;
      this.getConsultationStatistics();
    },
    handleCurrentChange(obj, e) {
      this.formInline.pageIndex = obj;
      this.Consultingstatistics();
    },
    Thequery2() {//查询
      this.Laborstatistics();
      this.LaborDataSb();
    },
    reset2() {
      this.formInline2.Name = "";
      this.formInline2.Date = [];
      this.formInline2.pageSize = "10";
      this.formInline2.pageIndex = "1";
      this.formInline2.DeriveText = "0";
      this.Laborstatistics();
    },
    export2() {
      this.formInline2.DeriveText = 1;
      this.Laborstatistics();
    },
    handleSizeChange2(obj, e) {
    },
    handleCurrentChange2(obj, e) {
      this.formInline2.pageIndex = obj;
      this.Laborstatistics();
    },
    reset3() {
      this.formInline2.Name = "";
      this.formInline2.Date = [];
      this.formInline2.pageSize = "10";
      this.formInline2.pageIndex = "1";
      this.formInline2.DeriveText = "0";
      this.Laborstatistics();
    },
    export3() {
      this.formInline3.DeriveText = 1;
      this.SheMessageStatisticLaif();
    },
    handleSizeChange3(obj, e) {},
    handleCurrentChange3(obj, e) {
      this.formInline3.DeriveText = 0;
      this.formInline3.pageIndex = obj;
      this.SheMessageStatisticLaif();
    },
    ClickReset(){
      localStorage.removeItem('ExamineStatistical');
      this.detailVOAppointmentTime=[];
      this.detailVOConsultTime=[];

      this.statisticsData = {
        pageNum:1,
        PageTotal:0,
        pageSize:10,
        detailVO:{
          Conditions:'',//综合查询条件
          Campus:'',//校区
          ConsultName:'',//咨询师
          ConsultType:'',//咨询方式
          States:[],//状态
          Crisis:'',//预警状态
          SchedulType:'',//排班类型
          Degree:"",//教育阶段
          Sex:'',
          ConsultSubject:'',
          DataType:'',//是否候补
          ConsultStartTime:'',
          ConsultEndTime:'',
          AppointmentStartTime:'',
          AppointmentEndTime:''
        }
      },



      // this.statisticsData=this.$options.data().statisticsData;
      this.Consultationquerystatistics();
    },
    handleClick(tab, event) {
      this.judge = tab.label;
      if (this.judge == "咨询统计") {
        this.Consultingstatistics();
      }else if(this.judge == "咨询查询"){
        this.Consultationquerystatistics();
        this.subjectFun();
      } else {
        this.Laborstatistics();
      }
    },
    Consultingstatistics() {//咨询统计
      if (this.formInline.DeriveText == 0) {
        this.loadings = true;
        this.$Http_Post("ConsultSubscribe/SheMessageStatisticXB", {from: this.formInline,}) //数据获取
          .then((res) => {
            this.loadings = false;
            if (res.Code == 200 || res.Code == 0) {
              this.tableData = res.Data;
              this.Counts = Number(res.Counts);
            }
          })
      } else {
        this.$Http_Post("ConsultSubscribe/SheMessageStatisticXB", { from: this.formInline }) //数据获取
          .then((res) => {
          this.loadings = false;
          if (res.Code == 200 || res.Code == 0) {
            this.formInline.DeriveText = 0
            window.open(res.Data, "titlebar=0");
          } else {
            this.Global.request_failure(res.Message)
          }
        })
      }
    },
    SheMessageStatisticLaif() {
      if (this.formInline3.DeriveText == 0) {
        this.loadings = true;
        this.formInline3.StartTime = this.formInline.Date[0]
        this.formInline3.EndTime =  this.formInline.Date[1]
        this.$Http_Post("ConsultSubscribe/SheMessageStatisticLaif", { from: this.formInline3, }) //数据获取
        .then((res) => {
          this.loadings = false;
          if (res.Code == 200 || res.Code == 0) {
            this.tableData3 = res.Data;
            this.Counts3 = Number(res.Counts);
            this.loadings = false;
          }
        })
      } else {
        this.formInline3.pageSize = "99999999";
        this.$Http_Post("ConsultSubscribe/SheMessageStatisticLaif", {from: this.formInline3,}) //数据获取
        .then((res) => {
          this.loadings = false;
          if (res.Code == 200 || res.Code == 0) {
            this.formInline3.DeriveText = 0;
            window.open(res.Data, "titlebar=0");
          }
        })
      }
    },
    Laborstatistics() {//劳务统计
      if (this.formInline2.DeriveText == 0) {
        this.loadings = true;
        this.$Http_Post("ConsultSubscribe/LaborDataXb", {from: this.formInline2,}) //数据获取
        .then((res) => {
          this.loadings = false;
          if (res.Code == 200 || res.Code == 0) {
            this.totalMny=res.Data.totalMny;
            this.tableData2 = res.Data.list;
            this.Counts2 = Number(res.Counts);
            this.loadings = false;
          }
        })
      } else {
        this.$Http_Post("ConsultSubscribe/LaborDataXb", {from: this.formInline2,}) //数据获取
        .then((res) => {
          this.loadings = false;
          if (res.Code == 200 || res.Code == 0) {
            this.formInline2.DeriveText = 0;
            window.open(res.Data, "titlebar=0");
          }
        })
      }
    },
    // 预约咨询查询
    Consultationquerystatistics(e){
      this.statisticsData.pageNum=e==0?1:this.statisticsData.pageNum;
      this.$Http_Post('statistics/getConsultDetailList',this.statisticsData).then(res=>{
        if(res.Code==0){
          this.PublicTable=res.Data;
          this.statisticsData.PageTotal=res.Counts;
        }
      })
    },
    // 分页
    handleinitialization(e){
      this.statisticsData.pageNum=e;
      this.Consultationquerystatistics();
    },
    // 咨询主题
    subjectFun(){
      this.$Http_Post('/User/GetDictionaryList', { DicTypCode:'25'}).then(res => {
        if (res.Code == 200 || res.Code == 0) {
          this.subjectData = res.Data;
        }
    })
  },
    SheMessageStatisticSB() {
      this.$Http_Post("ConsultSubscribe/SheMessageStatisticSB", { from: this.formInline}) //数据获取
        .then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.TotalCounts = res.Data.TotalCounts;
            this.Subscribe = res.Data.Subscribe;
            this.Consult = res.Data.Consult;
            this.ZxCancel = res.Data.ZxCancel;
            this.YuCancel = res.Data.YuCancel;
            this.NonArrival = res.Data.NonArrival;
            this.Reserve = res.Data.Reserve;

            
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.message,
          });
        });
    },
    LaborDataSb() {
      this.$Http_Post("ConsultSubscribe/LaborDataSb", { from: this.formInline2}) //数据获取
        .then((res) => {
          this.loadings = false;
          if (res.Code == 200 || res.Code == 0) {
            this.ConsultTime = res.Data.ConsultTime;
            this.KeepTime = res.Data.KeepTime;
            this.LeaveTime = res.Data.LeaveTime;
            this.WorkingTime = res.Data.WorkingTime;

            this.ArrivalTime = res.Data.ArrivalTime;
            this.NotArrivalTime= res.Data.NotArrivalTime;
            this.NotReserveTime= res.Data.NotReserveTime;
            this.ReserveTime= res.Data.ReserveTime;
          } else {
            this.Global.request_failure(res.Message);
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.message,
          });
        });
    },
  },
  mounted() {
    this.setSelectTime();
    this.getConsultationStatistics();
    this.Consultingstatistics();
    this.SheMessageStatisticSB();
    this.LaborDataSb();
    
    this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: '', content: '', }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.data = res.Data;
        this.options = res.Data;
      }
    });
    this.$Http_Post('/User/GetDictionaryList', { DicTypCode: '16' }).then(res => {
      if (res.Code == 200 || res.Code == 0) {
        this.SensoryProblemsList = res.Data;
      }
    });
    this.$Http_Post('/User/GetDictionaryList', { DicTypCode: '37' }).then(res => {
      if (res.Code == 200 || res.Code == 0) {
        this.zhuanyeList = res.Data;
      }
    });
    this.unitPrice_list()
  },
  
  components:{
    tabletest
  }
};
</script>
<style>
.ExamineStatistical {height: 100%;overflow: auto;}
.ExamineStatistical .minbtn{height: 23px !important;padding: 0px;}
.ExamineStatistical .right .el-date-editor .el-range__icon,
.ExamineStatistical .right .el-date-editor .el-range-separator,
.ExamineStatistical .right .el-date-editor .el-range__close-icon{line-height: 24px;}
.ExamineStatistical .el-range-editor .el-range-input{font-size: 12px;}
.ExamineStatistical .ExamineStatistical-top {height: 135px !important;background-color: #fff;}
.ExamineStatistical .ExamineStatistical-top h2 {font-size: 18px;padding: 0px 10px;}
.ExamineStatistical-top ul li {float: left;width: 10%;text-align: left;}
.ExamineStatistical-top ul li h3 {margin-left: 20px;font-size: 24px;color: rgba(0, 136, 255, 1);padding-top: 10px;}
.ExamineStatistical-top ul li p {margin-left: 20px;margin-top: 10px;}
.ExamineStatistical-nav {margin-top: 15px;background-color: #fff;padding: 20px;height: calc(100% - 1100px);}
.ExamineStatistical .block {float: right;margin-top: 20px;}
.ExamineStatistical .el-drawer {width: 50% !important;}
.ExamineStatistical .el-drawer__body .el-button {margin: 20px;}
.csadxscvf {margin: 20px;}

.el-table--enable-row-transition .el-table__body td {
  text-align: center;
}
.ExamineStatistical .xsjoij .el-input{width: 70%;}
.el-form-item{margin-bottom: 10px;}
.ExamineStatistical .nav{width: 100%;height: 900px;background-color: rgb(235, 236, 237);}
.ExamineStatistical .nav ul{height: 100%;}
.ExamineStatistical .nav ul li{float: left;height: 47.5%;margin-left: 1%;width: 49.5%;background-color: rgb(255, 255, 255);margin-top: 1%;}
#module .el-container{background-color: #fff;}
.CommonContentSingle-gray{background-color: #fff;}
</style>